<template>
  <div class="c-monitor">
    <!-- filter -->
    <list-filter
      ref="filter"
      slot="filter"
      :operator-data="operatorData"
      :state-data="stateData"
      :type-data="typeData"
      @on-change="filterData"
    />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <list-table
          :loading="loading"
          :data="tableData"
          :height="tableHeight"
          :columns="tableColumns"
          :state-data="stateData"
          :type-data="typeData"
          @on-retry="retryTask"
          @on-stop="stopTask"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import tableMixin from '../mixins/mixin_table'
import columns from '../data/derivative_list_column'
import { isArray, deepCopy } from '@/common/js/utils'
import { getVideoProcessPage, retryVideoProcessById, stopVideoProcessById } from '@/api/material.model'
import ListFilter from './components/list-filter'
import ListTable from './components/list-table'
import { getSysMember } from '@/api/common.model'

export default {
  name: 'DerivativeList',
  mixins: [tableMixin],
  components: { ListFilter, ListTable },
  data() {
    return {
      tableHeight: 330,
      tableData: [],
      tableColumns: [],
      operatorData: [],
      stateData: [
        { id: 3, name: '失败' },
        { id: 2, name: '已完成' },
        { id: 0, name: '未开始' },
        { id: 1, name: '进行中' },
        { id: 4, name: '已终止' }
      ],
      typeData: [
        { id: 1, name: '素材上传处理' },
        { id: 2, name: '批量视频处理' },
        { id: 3, name: '视频剪辑' }
      ]
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type: 2
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getVideoProcessPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = columns
              this.tableData = list.map((ret) => {
                ret.taskCnting = (ret.taskFailedCnt || 0) + (ret.taskSuccessCnt || 0)
                return ret
              })
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
            this.$nextTick(() => {
              this.$refs.derivativeTable && this.$refs.derivativeTable.doLayout()
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    retryTask(row) {
      const { id } = row
      this.$set(row, 'retring', true)
      retryVideoProcessById({ imageTaskId: id })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.$set(row, 'retring', false)
            data && this.getData()
          }
        })
        .catch(() => {
          this.$set(row, 'retring', false)
        })
    },
    stopTask(row) {
      const { id } = row
      this.$set(row, 'stoping', true)
      stopVideoProcessById({ imageTaskId: id })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.$set(row, 'stoping', false)
            data && this.getData()
          }
        })
        .catch(() => {
          this.$set(row, 'stoping', false)
        })
    },
    preloadData() {
      Promise.all([getSysMember()]).then((data) => {
        const [operatorData] = data
        if (isArray(operatorData)) this.operatorData = deepCopy(operatorData)
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
